import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {Button, Modal} from "react-bootstrap";
import {myService} from '@app/services/sukienService';
import {alertService} from '@app/services/alertService';
import {ClipLoader} from "react-spinners";
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import NhomsukienListComponent from "@pages/FUtil/NhomsukienListComponent";
import PhanloaisukienListComponent from "@pages/FUtil/PhanloaisukienListComponent";
import NhadanListComponent from "@pages/FUtil/NhadanListComponent";
import HinhthucListComponent from "@pages/FUtil/HinhthucListComponent";
import PhansuListComponent from "@pages/FUtil/PhansuListComponent";
import NewDatePicker from '@app/pages/FUtil/NewDatePicker';

const DaohuuchitietEditModal = ({
                                    showModal,
                                    initialObj,
                                    allowEdit,
                                    onHide,
                                    onSuccess,
                                    parentId,
                                    isHeader
                                }) => {
    const [t] = useTranslation();
    const [loading, setLoading] = useState(false);

    const initial = {
        id : 0,
        daohuuobj: null, // gọi trên BE tương tự daohuuobj
        nhomsukien_fk: null, // using component: NhomsukienListComponent
        phanloaisukien_fk: null, // using component PhanloaisukienListComponent
        daohuuchikieuobj: null, // using component DaohuuAutocompleteComponent
        daohuuchungminhobj: null, // using component DaohuuAutocompleteComponent
        phansu_fk: null, // using component PhansuListComponent
        nhadan_fk: null, // using component NhadanListComponent
        trangthaiphansu_fk: null, // using component TrangthaiListComponent
        trangthaidotso_fk: 0, // mặc định = 0
        trangthaixinkeo_fk: null, // using component TrangthaiListComponent
        hinhthuc_fk: null, // using component TrangthaiListComponent
        ngay_sac_phong: '', // input
        trangthaiketqua_fk: null, // using component TrangthaiListComponent
        ngay_su_kien_chi_tiet: '', // input - cho lên đầu
        ghi_chu: '' // textarea
    };

    const [obj, setObj] = useState(initialObj || {...initial});

    // Update obj when initialObj changes
    React.useEffect(() => {
        if (initialObj) {
            // Transform data from API format to modal format
            const transformedObj = {
                ...initialObj,
                // Parse JSON strings to objects if they're strings
                daohuuobj: typeof initialObj.daohuuobj === 'string'
                    ? JSON.parse(initialObj.daohuuobj)
                    : initialObj.daohuuobj,
                daohuuchikieuobj: initialObj.daohuuchikieuobj
                    ? (typeof initialObj.daohuuchikieuobj === 'string'
                        ? JSON.parse(initialObj.daohuuchikieuobj)
                        : initialObj.daohuuchikieuobj)
                    : null,
                daohuuchungminhobj: initialObj.daohuuchungminhobj
                    ? (typeof initialObj.daohuuchungminhobj === 'string'
                        ? JSON.parse(initialObj.daohuuchungminhobj)
                        : initialObj.daohuuchungminhobj)
                    : null,
                // Ensure date fields are properly formatted
                ngay_su_kien_chi_tiet: initialObj.ngay_su_kien_chi_tiet || '',
                ngay_sac_phong: initialObj.ngay_sac_phong || ''
            };
            setObj(transformedObj);
        } else {
            setObj({...initial});
        }
    }, [initialObj]);

    // Function để tính ngày sắc phong dựa trên ngày sự kiện chi tiết
    const calculateNgaySacPhong = (ngaySuKien) => {
        if (!ngaySuKien) return '';

        const date = new Date(ngaySuKien);
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // JavaScript month is 0-indexed
        const day = date.getDate();

        // Xác định mốc ngày sắc phong dựa trên tháng và ngày
        let sacPhongMonth, sacPhongYear = year;

        if (month === 1 && day <= 14) {
            sacPhongMonth = 1; // 14/1
        } else if (month <= 3 || (month === 4 && day <= 14)) {
            sacPhongMonth = 4; // 14/4
        } else if (month <= 6 || (month === 7 && day <= 14)) {
            sacPhongMonth = 7; // 14/7
        } else if (month <= 9 || (month === 10 && day <= 14)) {
            sacPhongMonth = 10; // 14/10
        } else {
            // Nếu sau 14/10 thì chuyển sang 14/1 năm sau
            sacPhongMonth = 1;
            sacPhongYear = year + 1;
        }

        return `${sacPhongYear}-${sacPhongMonth.toString().padStart(2, '0')}-14`;
    };

    const onChangeInput = (e) => {
        const {name, value, checked} = e.target;

        setObj((prevState) => {
            let newState = { ...prevState, [name]: value };

            if (name === "nhomsukien_fk") {
                newState.phanloaisukien_fk = "";
            }

            // Tự động tính ngày sắc phong khi thay đổi ngày sự kiện chi tiết
            if (name === "ngay_su_kien_chi_tiet") {
                newState.ngay_sac_phong = calculateNgaySacPhong(value);
            }

            return newState;
        });
    };

    const handleModalSave = async () => {
        let data = obj;
        if (!data) {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if (!data.daohuuobj) {
            alert('Vui lòng chọn đạo hữu');
            return;
        }

        if (!data.nhomsukien_fk || data.nhomsukien_fk.length === 0) {
            alert('Vui lòng chọn nhóm sự kiện');
            return;
        }

        if (!data.phanloaisukien_fk || data.phanloaisukien_fk.length === 0) {
            alert('Vui lòng chọn phân loại sự kiện');
            return;
        }

        // Validation cho Phận sự khi nhóm sự kiện = 13
        if (data.nhomsukien_fk === 13 && (!data.phansu_fk || data.phansu_fk.length === 0)) {
            alert('Vui lòng chọn phận sự');
            return;
        }

        // Validation cho Nhà đàn khi phân loại sự kiện = 46
        if (data.phanloaisukien_fk === 46 && (!data.nhadan_fk || data.nhadan_fk.length === 0)) {
            alert('Vui lòng chọn nhà đàn');
            return;
        }

        // Validation cho Trạng thái phận sự thượng cung khi phân loại sự kiện = 48
        if (data.phanloaisukien_fk === 48 && (!data.trangthaiphansu_fk || data.trangthaiphansu_fk.length === 0)) {
            alert('Vui lòng chọn trạng thái phận sự thượng cung');
            return;
        }

        // Validation cho Xin keo (bắt buộc chọn)
        if (!data.trangthaixinkeo_fk || data.trangthaixinkeo_fk.length === 0) {
            alert('Vui lòng chọn xin keo');
            return;
        }

        if(data.id && data.id !== '0' && data.id !== 0 ) {
            await updateRecord(data);
        } else {
            await createRecord(data);
        }
    };

    async function createRecord(data) {
        setLoading(true);
        try {
            const result = await myService.Create_Daohuuchitiet(parentId, data);
            if (result.status === "1") {
                alertService.success(result.msg);
                onSuccess(); // Notify parent to refresh data
                onHide(); // Close modal
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi tạo dữ liệu');
        }
        setLoading(false);
    }

    async function updateRecord(data) {
        setLoading(true);
        try {
            const result = await myService.Update_Daohuuchitiet(data.id, data);
            if (result.status === "1") {
                alertService.success(result.msg);
                onSuccess(); // Notify parent to refresh data
                onHide(); // Close modal
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi cập nhật dữ liệu');
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <Modal size="xl" show={showModal} onHide={onHide}>
                <Modal.Body>
                    <div className="flex justify-center items-center h-40">
                        <ClipLoader color="#3498db" size={50} />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <Modal size="xl" show={showModal} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>
                    Thông tin đạo hữu chi tiết
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6">
                        {/* Ngày sự kiện chi tiết - cho lên đầu */}
                        <div className='form-group'>
                            <label className="required">Ngày sự kiện chi tiết</label>
                            <NewDatePicker className="form-control w-100" isV2
                                           id="ngay_su_kien_chi_tiet"
                                           name="ngay_su_kien_chi_tiet" value={obj.ngay_su_kien_chi_tiet}
                                           onDayChange={onChangeInput} />
                        </div>

                        <div className='form-group'>
                            <label htmlFor="daohuuobj" className={"required"}>Đạo hữu</label>
                            <DaohuuAutocompleteComponent
                                path_access={isHeader ? "sukien":"sukien_daohuu"}
                                id_tableName={parentId}
                                currentSuggestion={obj.daohuuobj}
                                onChange={(e) => {
                                    const target = {name: 'daohuuobj', value: e?.value};
                                    onChangeInput({ target })
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <NhomsukienListComponent
                                required={true}
                                nhomsukien_fk={obj.nhomsukien_fk}
                                coquan_fk={4}
                                onChange={(opt, e) => {
                                    const target = {name: "nhomsukien_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <PhanloaisukienListComponent
                                required={true}
                                phanloaisukien_fk={obj.phanloaisukien_fk}
                                nhomsukien_fk={obj.nhomsukien_fk ? obj.nhomsukien_fk : -1} //để không load all khi chưa chọn Nhóm sk
                                onChange={(opt, e) => {
                                    const target = {name: "phanloaisukien_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        {/* Chỉ hiện Phận sự khi nhóm sự kiện = 13 */}
                        {obj.nhomsukien_fk === 13 && (
                            <div className='form-group'>
                                <PhansuListComponent
                                    required={true}
                                    value={obj.phansu_fk}
                                    coquan_fk={obj.coquan_fk ? obj.coquan_fk : -1} //để không load all khi chưa chọn Nhóm sk
                                    name="Phận sự"
                                    onChange={(opt, e) => {
                                        const target = {name: "phansu_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                        )}

                        {/* Chỉ hiện Nhà đàn khi phân loại sự kiện = 46 */}
                        {obj.phanloaisukien_fk === 46 && (
                            <div className='form-group'>
                                <NhadanListComponent
                                    loainhadan_fk_smaller={6} //lấy Hoàng đàn và Phật đàn, quy định riêng trong BE
                                    nhadan_fk={obj.nhadan_fk}
                                    coquan
                                    onChange={(opt, e) => {
                                        const target = {name: "nhadan_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                        )}

                        <div className='form-group'>
                            <label htmlFor="daohuuchikieuobj">Phối sư CK</label>
                            <DaohuuAutocompleteComponent
                                path_access={isHeader ? "sukien":"sukien_daohuu"}
                                id_tableName={parentId}
                                currentSuggestion={obj.daohuuchikieuobj}
                                onChange={(e) => {
                                    const target = {name: 'daohuuchikieuobj', value: e?.value};
                                    onChangeInput({ target })
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <label htmlFor="daohuuchungminhObj">Phối sư CM</label>
                            <DaohuuAutocompleteComponent
                                path_access={isHeader ? "sukien":"sukien_daohuu"}
                                id_tableName={parentId}
                                currentSuggestion={obj.daohuuchungminhobj}
                                onChange={(e) => {
                                    const target = {name: 'daohuuchungminhobj', value: e?.value};
                                    onChangeInput({ target })
                                }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        {/* Ngày sắc phong - tự động tính */}
                        <div className='form-group'>
                            <label className="required">Ngày sắc phong</label>
                            <NewDatePicker className="form-control w-100" isV2
                                           id="ngay_sac_phong" name="ngay_sac_phong" value={obj.ngay_sac_phong}
                                           onDayChange={onChangeInput} />
                        </div>

                        {/* Chỉ hiện Trạng thái phận sự thượng cung khi phân loại sự kiện = 48 */}
                        {obj.phanloaisukien_fk === 48 && (
                            <div className='form-group'>
                                <TrangthaiListComponent
                                    trangthai_fk={obj.trangthaiphansu_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "trangthaiphansu_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                    label='Trạng thái phận sự Thượng cung'
                                    trangthaiName="phansu"
                                    filterIds={[0,1,2,3,4]}
                                />
                            </div>
                        )}

                        <div className='form-group'>
                            <TrangthaiListComponent
                                trangthai_fk={obj.trangthaidotso_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "trangthaidotso_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                                label='Đốt sớ'
                                trangthaiName="dotso"
                                filterIds={[0,1,2]}
                            />
                        </div>

                        <div className='form-group'>
                            <TrangthaiListComponent
                                name="trangthaixinkeo_fk"
                                trangthai_fk={obj.trangthaixinkeo_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "trangthaixinkeo_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                                trangthaiName="xinkeo"
                                filterIds={[0,1,2]}
                                label='Xin keo'
                            />
                        </div>

                        <div className='form-group'>
                            <HinhthucListComponent
                                value={obj.hinhthuc_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "hinhthuc_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <TrangthaiListComponent
                                trangthai_fk={obj.trangthaiketqua_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "trangthaiketqua_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                                trangthaiName="ketqua"
                                filterIds={[0,1]}
                                label='Kết quả'
                            />
                        </div>

                        <div className='form-group'>
                            <label htmlFor="ghi_chu">Ghi chú</label>
                            <textarea
                                className="form-control"
                                name="ghi_chu"
                                rows="4"
                                value={obj.ghi_chu}
                                onChange={onChangeInput}
                                placeholder="Nhập ghi chú..."
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {"Thoát"}
                </Button>
                { allowEdit && (<Button variant="primary" onClick={handleModalSave}>
                    {"Xác nhận"}
                </Button>) }
            </Modal.Footer>
        </Modal>
    );
};

export default DaohuuchitietEditModal;